const parseBooleanFeatureFlag = (value: string | undefined, defaultValue: boolean): boolean => {
  if (value == null || value.trim() === '') {
    return defaultValue;
  }

  return value === '1' || value.toLowerCase() === 'true';
};

export const isBankDocumentsQueueEnabled = parseBooleanFeatureFlag(
  process.env.REACT_APP_BANK_DOCUMENTS_QUEUE_ENABLED,
  false
);

export const isSupplierPrepaymentsEnabled = parseBooleanFeatureFlag(
  process.env.REACT_APP_SUPPLIER_PREPAYMENTS_ENABLED,
  true
);

export const isBankDocumentsReservationQuickCreateEnabled = parseBooleanFeatureFlag(
  process.env.REACT_APP_BANK_DOCUMENTS_RESERVATION_QUICK_CREATE_ENABLED,
  true
);
